var _style, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBicycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__prefix__st0 {\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-linecap: round;\n\t\t\tstroke-linejoin: round;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\n\t\t.prefix__prefix__st1 {\n\t\t\tfill: #414141\n\t\t}\n\t")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "prefix__prefix__st0",
    cx: 12.2,
    cy: 14.9,
    r: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__prefix__st1",
    d: "M5 10.9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4m0-1c-2.7 0-5 2.2-5 5 0 2.7 2.2 5 5 5 2.7 0 5-2.2 5-5-.1-2.7-2.3-5-5-5zm14 1c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4m0-1c-2.7 0-5 2.2-5 5 0 2.7 2.2 5 5 5 2.7 0 5-2.2 5-5 0-2.7-2.2-5-5-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__prefix__st0",
    d: "M18.6 13.9l-1.8-7.6c-.1-.4 0-.8.2-1.2.2-.4.6-.6 1-.7l1.5-.3M11.9 14L10 10.5c-.2-.3-.2-.7 0-1 .1-.3.4-.5.8-.5L17 7.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#414141",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5.8 14.9h5.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__prefix__st0",
    d: "M9.1 8.1L8 6.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#414141",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M6.4 6.2h3.9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "prefix__prefix__st1",
    cx: 5,
    cy: 14.9,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "prefix__prefix__st1",
    cx: 19,
    cy: 14.9,
    r: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicycle);
export default __webpack_public_path__ + "static/media/bicycle.2dd0950e5cf0c4c3c3718ed62794d711.svg";
export { ForwardRef as ReactComponent };